var React = require('react');

function UpRightIconInline (props) {
    return React.createElement("svg",props,[React.createElement("polyline",{"points":"20.56,14.04   35.96,14.04 35.959,29.44 ","fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"2","key":0}),React.createElement("line",{"fill":"none","stroke":"#000000","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"2","x1":"13.372","x2":"35.55","y1":"36.627","y2":"14.45","key":1})]);
}

UpRightIconInline.defaultProps = {"enableBackground":"new 0 0 50 50","height":"50px","version":"1.1","viewBox":"0 0 50 50","width":"50px","xmlSpace":"preserve"};

module.exports = UpRightIconInline;

UpRightIconInline.default = UpRightIconInline;
